import React from 'react';
import { Row, Col, Card, Drawer, Button, Avatar } from 'antd';
import { CloseOutlined, UserOutlined } from '@ant-design/icons';
import { inject, observer } from 'mobx-react';
import UpdateTel from './UpdateTel';
import UpdatePassword from './updatePassword';
import s from './style.module.less';

const Setting = (props) => {
    const { global, login } = props.store;

    const onCloseDrawer = () => {
        login.setSettingMode('setting');
        global.setSettingVisible(false);
    };
    const genPhoneNumber = (phone) => {
        phone = String(phone);
        return phone.substring(0, 3) + '****' + phone.substring(7);
    };

    return (
        <Drawer
            className={s.login}
            title="账号与安全"
            width={550}
            open={global.settingVisible}
            closable={false}
            destroyOnClose={true}
            maskClosable={false}
            keyboard={false}
            extra={<CloseOutlined onClick={onCloseDrawer} />}
        >
            {login.settingMode === 'setting' ? (
                <>
                    <div style={{ textAlign: 'center', margin: '20px 0' }}>
                        <Avatar size={100} icon={<UserOutlined />} src={login.userInfo?.avatar || '/asset/images/avatar_default_big.png'} />
                        <p style={{ margin: '10px 0 30px' }}>{login.userInfo?.adminInfo?.admin_name}</p>
                    </div>
                    <Card>
                        <Row>
                            <Col span="18">
                                <div>绑定手机号</div>
                                <div>{genPhoneNumber(login.userInfo?.mobile)}</div>
                            </Col>
                            <Col span="6" style={{ textAlign: 'right', lineHeight: '72px' }}>
                                <Button
                                    type="link"
                                    onClick={() => {
                                        login.setSettingMode('updateTel');
                                    }}
                                >
                                    修改
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                    <Card style={{ marginTop: '20px' }}>
                        <Row>
                            <Col span="18">
                                <div>登录密码</div>
                                <div>*********</div>
                            </Col>
                            <Col span="6" style={{ textAlign: 'right', lineHeight: '72px' }}>
                                <Button
                                    type="link"
                                    onClick={() => {
                                        login.setSettingMode('updatePassword');
                                    }}
                                >
                                    修改
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                </>
            ) : login.settingMode === 'updateTel' ? (
                <UpdateTel />
            ) : login.settingMode === 'updatePassword' ? (
                <UpdatePassword />
            ) : null}
        </Drawer>
    );
};

export default inject('store')(observer(Setting));
